import { Injectable } from '@angular/core';
import { setDefaultOptions, loadModules } from 'esri-loader';

import { environment } from '../../environments/environment';

export let LoadedModules: any = null;
let esriLoaderService: EsriLoadService = null;

@Injectable()
export class EsriLoadService {
    loading: boolean = false;
    waitInterval: any = null;
    constructor() {
        esriLoaderService = this;
    }

    async loadClass() {
        if(LoadedModules == null && !this.loading){
            this.loading = true;

            return loadModules([
              "esri/Map",
              "esri/geometry/geometryEngineAsync",
              "esri/rest/support/RouteParameters",
              "esri/geometry/support/webMercatorUtils",
              "esri/widgets/Expand",
              "esri/views/MapView",
              "esri/widgets/Sketch",
              "esri/widgets/Sketch/SketchViewModel",
              "esri/Color",
              "esri/rest/route",
              "esri/symbols/PictureMarkerSymbol",
              "esri/Graphic",
              "esri/PopupTemplate",
              "esri/geometry/Extent",
              "esri/geometry/Circle",
              "esri/geometry/Point",
              "esri/widgets/BasemapGallery",
              "esri/Basemap",
              "esri/widgets/BasemapLayerList",
              "esri/geometry/Polyline",
              "esri/layers/GraphicsLayer",
              "esri/geometry/geometryEngine",
              "esri/geometry/SpatialReference",
              "esri/rest/support/FeatureSet",
              "esri/geometry/Circle",
              "esri/config",
              "esri/geometry/support/jsonUtils" ,
              "esri/rest/support/PointBarrier",
              "esri/rest/support/PolylineBarrier",
              "esri/rest/support/PolygonBarrier",
              "esri/geometry/Polygon",
          ])
            .then(([
              _Map,
              _geometryEngineAsync,
              _RouteParameters,
              _webMercatorUtils,
              _Expand,
              _MapView,
              _Sketch,
              _SketchViewModel,
              _Color,
              _RouteTask,
              _PictureMarkerSymbol,
              _graphic,
              _PopupTemplate,
              _Extent,
              _Circle,
              _Point,
              _BasemapGallery,
              _Basemap,
              _BasemapLayer,
              _Polyline,
              _GraphicsLayer,
              _GeometryEngine,
              _SpatialReference,
              _FeatureSet,
              _Units,
              _Config,
              _JsonUtils,
              _PointBarrier,
              _PolylineBarrier,
              _PolygonBarrier,
              _Polygon
              ]) => {
            //aqui colocar o Loade
            LoadedModules = {
              Map: _Map,
              geometryEngineAsync: _geometryEngineAsync,
              RouteParameters: _RouteParameters,
              webMercatorUtils: _webMercatorUtils,
              Expand: _Expand,
              MapView: _MapView,
              Sketch: _Sketch,
              SketchViewModel: _SketchViewModel,
              Color: _Color,
              RouteTask: _RouteTask,
              PictureMarkerSymbol: _PictureMarkerSymbol,
              Graphic: _graphic,
              PopupTemplate: _PopupTemplate,
              Extent: _Extent,
              Circle: _Circle,
              Point: _Point,
              BasemapGallery: _BasemapGallery,
              Basemap: _Basemap,
              BasemapLayer: _BasemapLayer,
              Polyline: _Polyline,
              GraphicsLayer: _GraphicsLayer,
              GeometryEngine: _GeometryEngine,
              SpatialReference: _SpatialReference,
              FeatureSet: _FeatureSet,
              EsriUnits: _Units,
              EsriConfig: _Config,
              JsonUtils: _JsonUtils,
              PointBarrier:_PointBarrier,
              PolylineBarrier:_PolylineBarrier,
              PolygonBarrier: _PolygonBarrier,
              Polygon: _Polygon, 
          }
            });
        }
        else {
            return new Promise((resolve, reject) => {
                esriLoaderService.waitInterval = setInterval(function() {
                    if(LoadedModules != null) {
                        clearInterval(esriLoaderService.waitInterval);
                        resolve(() =>{});
                    }
                }, 100);
            });
        }
    }
}
